export default __webpack_public_path__ + "static/media/icon-troisPoints.cd3ffc15.svg";